import React from "react";
import { Banner, BannerProps } from "@appComponents/Banner/Banner";

type CustodyBannerProps = Pick<BannerProps, "hideCloseBtn">;

export const CustodyBanner = ({ hideCloseBtn }: CustodyBannerProps) => {
  return (
    <Banner variant="purple" title="Custody" hideCloseBtn={hideCloseBtn}>
      Public Shares are kept in custody with BF Global IB MU, an Investment
      Dealer regulated in Mauritius. BF GLOBAL IB MU is regulated by the
      Mauritius Financial Services Commission (FSC) as a Full Service Dealer,
      excluding Underwriting.
    </Banner>
  );
};
